define('modules/targeting/pixel/main',["T1Module"], function (T1Module) {
  "use strict";

  return new T1Module({
    name: "targeting/pixel",
    viewCfgs: {
      panel: {
        strategy: null
      },
      bins: {
        sharedCollection: null
      },
      readOnly: {
        model: null
      }
    },
    defaultView: "panel"
  });
});
